import React from 'react';
import styled from 'styled-components/macro';
import { components } from 'react-select';
import { MdCreateNewFolder } from 'react-icons/md';
import { Button } from 'react-covideo-common';

const MenuHeader = styled.div`
  cursor: pointer;
  padding: 20px 20px 10px 20px;
`;

const MenuOption = styled.div`
  padding: 10px 20px 20px 20px;
`;

export const ButtonText = styled.span`
  font-family: Work Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;
`;

export const Icon = styled.div<{ loading?: boolean }>`
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.secondary[5]};
`;

type Props = {
  menuProps: any;
  showCreateButton?: boolean;
  onCreateNewFolder?: () => void;
};

export const CustomMenuList = ({
  menuProps,
  showCreateButton = true,
  onCreateNewFolder,
}: Props) => (
  <components.MenuList {...menuProps}>
    {showCreateButton && (
      <>
        <MenuHeader>
          <Button
            onClick={onCreateNewFolder}
            variant='secondary'
            icon={<MdCreateNewFolder size={24} />}
            text='Create new Folder'
            extendStyles={{
              container: {
                width: '100%',
                maxWidth: '100%',
                minWidth: '100%',
                height: 60,
                minHeight: 60,
                maxHeight: 60,
              },
            }}
          />
        </MenuHeader>
        <Divider />
      </>
    )}
    <MenuOption>{menuProps.children}</MenuOption>
  </components.MenuList>
);
